import { render, staticRenderFns } from "./WiaaCertificationDetails.vue?vue&type=template&id=91063802&scoped=true&"
import script from "./WiaaCertificationDetails.vue?vue&type=script&lang=js&"
export * from "./WiaaCertificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91063802",
  null
  
)

export default component.exports